import React, { CSSProperties } from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import GlobalAlert from '@src/components/GlobalAlert'

const PageError: React.FC<{
  showError: boolean
  rootStyle?: CSSProperties
}> = ({ showError = false, rootStyle }) => {
  return showError ? (
    <Grid item xs={12} style={rootStyle}>
      <GlobalAlert severity="error">
        <FormattedMessage
          id="CONF_DNAPLATES_ERROR_STEP2"
          defaultMessage="Please correct the error(s) before proceeding to the next step."
        />
      </GlobalAlert>
    </Grid>
  ) : (
    <></>
  )
}

export default PageError
